import React from 'react';
import PropTypes from 'prop-types';

const Trans = ({ children, translations }) => {
    // lookup translation in translations object
    const translation = translations[children]
        ? translations[children]
        : children;
    return <span className="trans">{translation}</span>;
};

Trans.propTypes = {
    children: PropTypes.any.isRequired,
    translations: PropTypes.objectOf(PropTypes.string).isRequired,
};

export const transString = (text, translations) =>
    (translations[text] ? translations[text] : text);

export default Trans;



// WEBPACK FOOTER //
// ./static/js/modules/locations-finder/helpers/Trans.js